export const ENTITY_VIEWER_MODE = {
  EDIT: Symbol.for('EDIT'),
  NEW: Symbol.for('NEW'),
  VIEW: Symbol.for('VIEW'),
  NONE: Symbol.for('NONE')
}
